import AccessExport from './export/access.js'
import SubscriptionExport from './export/subscriptions.js'
import BillingExport from './export/billing.js'
import Login from './login.js'
import Dashboard from './dashboard.js'
import Search from './search.js'

module.exports = {
  AccessExport,
  SubscriptionExport,
  BillingExport,
  Login,
  Dashboard,
  Search
}



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/core/index.js